import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonType } from '../../button/types/type';
import { TooltipTriggerWrapperStyled } from '../tooltip.styled';
export const TooltipTrigger = (props) => {
    if (props.childrenAsButton) {
        return (_jsx(TooltipTriggerWrapperStyled, { "aria-describedby": props.ariaDescribedBy, "aria-disabled": props.disabled, ...props.triggerAsButton, disabled: props.disabled, type: ButtonType.BUTTON, onClick: props.onClick, onKeyDown: props.onKeyDown, onMouseDown: props.onMouseDown, onMouseUp: props.onMouseUp, children: props.children }));
    }
    return (_jsx(TooltipTriggerWrapperStyled, { as: "div", onClick: props.onClick, onKeyDown: props.onKeyDown, onMouseDown: props.onMouseDown, onMouseUp: props.onMouseUp, children: props.children }));
};
//# sourceMappingURL=tooltipTrigger.js.map